// import React, { useState, useMemo, useEffect } from "react";
// import { styled } from "@mui/material/styles";
// import { Link } from "react-router-dom";
// import styles from "./SubMenu.module.css";
// import { useLocation } from "react-router-dom";

// import EnlargedView from "../../utils/EnlargedView";

// const SubMenu = ({ item, isActive, setIsActive }) => {
//   const role = JSON.parse(localStorage.getItem("loggedInDetails"));
//   const [currentPath, setCurrentPath] = useState("");
//   const router = useLocation();
//   useMemo(() => {
//     setCurrentPath(router.pathname);
//   }, [router]);

//   const [open, setOpen] = useState(false);
//   const [content, setContent] = useState();
//   return (
//     <div style={{ position: "relative", overflow: "visible" }}>
//       <EnlargedView open={open} setOpen={setOpen} content={content} />
//       <div
//         style={{
//           position: "relative",
//           overflow: "visible",
//           background: "var(--themeColor)",
//           height: "fit-content",
//           // borderBottomRightRadius: "10px",
//           // borderBottomLeftRadius: "10px",
//           borderRadius:"7px",
//           width:"100%",
//           maxWidth: "167px",
//           // marginBottom: "1rem",
//           // ,paddingLeft:"1rem"
//         }}
//         onMouseOver={() => {
//           setIsActive(item.path.split("/")[1]);
//         }}
//         onMouseOut={() => {
//           setIsActive();
//         }}
//       >
//         <Link
//           to={
//             item.subNav == undefined &&
//             (currentPath.split("/").pop() == item.path.split("/").pop()
//               ? currentPath
//               : item.path)
//           }
//           onClick={() => {
//             if (isActive == item.path.split("/")[1]) setIsActive();
//             else {
//               setIsActive(item.path.split("/")[1]);
//             }
//           }}
//           className={`${styles.sidebarLink} ${
//             currentPath.split("/")[1] == item.path.split("/")[1] &&
//             "sidebarLinkActive"
//           } ${
//             role?.id?.userType?.roleName == "Advertiser"
//               ? styles.inlinetext
//               : ""
//           }`}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               width: "max-content",
//               // justifyContent:"center"
//             }}
//           >
//             <span >{item.icon}</span>
//             <span className="ml-1">{item.title}</span>
//           </div>

//           <div style={{ display: "flex", color: "var(--themeFontColor)" }}>
//             {/* {item?.access != "true" && !item.subNav && <div><img src="https://i.ibb.co/k20TGP4/Lock1.png" height={"20px"} /></div>} */}
//             {item.subNav && item.iconOpened}
//           </div>
//         </Link>
//         {item.subNav && isActive == item.path.split("/")[1] && (
//           <div
//             style={{
//               boxShadow: "var(--themeShadow)",
//               background: "var(--themeColor)",
//               margin: ".2rem",
//               right: item.title == "Settings" && "0",
//               borderRadius: "10px",
//               margin: "0",
//               position: "absolute",
//               top: "2.5rem",
//               zIndex: "1000",
//               width: "max-content",
//             }}
//           >
//             {item.subNav.map((item, index) => {
//               return (
//                 <Link
//                   to={item.path}
//                   key={index}
//                   // onClick={() => {
//                   //   if (item?.access != "true") {
//                   //     setContent(
//                   //       <p style={{ color: "black" }}>
//                   //         You don't have permission to view this module
//                   //       </p>
//                   //     );
//                   //     setOpen(true)
//                   //   }

//                   // }}
//                   className={`${styles.sidebarLink2} ${
//                     currentPath == item.path && "sidebarLinkActive2"
//                   }`}
//                   style={{ display: "flex", justifyContent: "space-between" }}
//                 >
//                   {item.icon}
//                   {item.title}
//                   {/* {item?.access != "true" && <div><img src="https://i.ibb.co/k20TGP4/Lock1.png" height={"30px"} /></div>} */}
//                 </Link>
//               );
//             })}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SubMenu;

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const SubMenu = ({ item, darkMode, activeDropdown, setActiveDropdown, isMobile }) => {
  const location = useLocation();
  const [hoverTimeout, setHoverTimeout] = useState(null);
  
  const isCurrentActive = location.pathname.split("/")[1] === item.path.split("/")[1];
  const isDropdownOpen = activeDropdown === item.path.split("/")[1] && !isMobile;

  const handleMouseEnter = () => {
    if (isMobile) return;
    
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
    if (item.subNav) {
      setActiveDropdown(item.path.split("/")[1]);
    }
  };

  const handleMouseLeave = () => {
    if (isMobile) return;
    
    if (item.subNav) {
      const timeout = setTimeout(() => {
        setActiveDropdown(null);
      }, 200);
      setHoverTimeout(timeout);
    }
  };

  const handleDropdownMouseEnter = () => {
    if (isMobile) return;
    
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
  };

  const handleDropdownMouseLeave = () => {
    if (isMobile) return;
    
    const timeout = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
    setHoverTimeout(timeout);
  };

  useEffect(() => {
    return () => {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
    };
  }, [hoverTimeout]);

  return (
    <div 
      className={`relative group ${isMobile ? 'flex-shrink-0' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Main Menu Item */}
      <Link
        to={item.subNav ? "#" : item.path}
        className="block"
        onClick={(e) => {
          if (item.subNav) {
            e.preventDefault();
            if (isMobile) {
              setActiveDropdown(activeDropdown === item.path.split("/")[1] ? null : item.path.split("/")[1]);
            }
          }
        }}
      >
        <div className={`
          flex items-center gap-2 px-3 py-3 rounded-xl transition-all duration-300 ease-out cursor-pointer
          ${isMobile 
            ? 'min-w-[48px] justify-center' 
            : 'min-w-[140px] justify-center'
          }
          ${isCurrentActive 
            ? (darkMode 
                ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg shadow-blue-500/25' 
                : 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg shadow-blue-500/25'
              )
            : (darkMode
                ? 'bg-gray-800/80 text-gray-300 hover:bg-gray-700 hover:text-white border border-gray-700/50 hover:border-gray-600'
                : 'bg-gray-50/80 text-gray-700 hover:bg-gray-100 hover:text-gray-900 border border-gray-200/50 hover:border-gray-300'
              )
          }
          hover:scale-105 hover:shadow-lg
          ${isDropdownOpen && !isCurrentActive && (darkMode ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-900')}
        `}>
          <span className="text-lg">
            {item.icon}
          </span>
          {!isMobile && (
            <>
              <span className="font-medium text-sm whitespace-nowrap">
                {item.title}
              </span>
              {item.subNav && (
                <item.iconOpened 
                  size={16} 
                  className={`transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}
                />
              )}
            </>
          )}
        </div>
      </Link>

      {/* Mobile Dropdown - Shows below */}
      {isMobile && item.subNav && activeDropdown === item.path.split("/")[1] && (
        <div className="absolute top-full left-0 mt-2 z-50 w-48">
          <div className={`absolute -top-1 left-6 w-3 h-3 rotate-45 ${darkMode ? 'bg-gray-800 border-l border-t border-gray-700' : 'bg-white border-l border-t border-gray-200'}`}></div>
          
          <div className={`
            ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} 
            border rounded-xl shadow-2xl py-3
            animate-in slide-in-from-top-2 duration-200
          `}>
            {item.subNav.map((subItem, index) => (
              <Link
                key={index}
                to={subItem.path}
                className={`
                  flex items-center gap-3 px-4 py-3 mx-2 rounded-lg
                  transition-all duration-200 group
                  ${location.pathname === subItem.path
                    ? (darkMode 
                        ? 'bg-blue-600 text-white shadow-md' 
                        : 'bg-blue-500 text-white shadow-md'
                      )
                    : (darkMode
                        ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
                        : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                      )
                  }
                  hover:scale-105
                `}
                onClick={() => setActiveDropdown(null)}
              >
                <span className="text-base opacity-80 group-hover:opacity-100">
                  {subItem.icon}
                </span>
                <span className="font-medium text-sm whitespace-nowrap">
                  {subItem.title}
                </span>
              </Link>
            ))}
          </div>
        </div>
      )}

      {/* Desktop Dropdown Menu */}
      {!isMobile && item.subNav && isDropdownOpen && (
        <div 
          className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 z-50"
          onMouseEnter={handleDropdownMouseEnter}
          onMouseLeave={handleDropdownMouseLeave}
        >
          <div className={`absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 rotate-45 ${darkMode ? 'bg-gray-800 border-l border-t border-gray-700' : 'bg-white border-l border-t border-gray-200'}`}></div>
          
          <div className={`
            ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} 
            border rounded-xl shadow-2xl py-3 min-w-[220px]
            animate-in slide-in-from-top-2 duration-200
          `}>
            {item.subNav.map((subItem, index) => (
              <Link
                key={index}
                to={subItem.path}
                className={`
                  flex items-center gap-3 px-4 py-3 mx-2 rounded-lg
                  transition-all duration-200 group
                  ${location.pathname === subItem.path
                    ? (darkMode 
                        ? 'bg-blue-600 text-white shadow-md' 
                        : 'bg-blue-500 text-white shadow-md'
                      )
                    : (darkMode
                        ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
                        : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                      )
                  }
                  hover:scale-105
                `}
              >
                <span className="text-base opacity-80 group-hover:opacity-100">
                  {subItem.icon}
                </span>
                <span className="font-medium text-sm whitespace-nowrap">
                  {subItem.title}
                </span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubMenu;

